'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;
/* injects from baggage-loader */

/*

    Given project, returns a project, rendered in <svg>

    Computes the nodes bounding boxes and uses <StaticProjectView> for rendering

*/

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _StaticProjectView = require('components/Projects/StaticProjectView');

var _StaticProjectView2 = _interopRequireDefault(_StaticProjectView);

var _getProjectDimentions2 = require('components/Projects/utils/getProjectDimentions');

var _getProjectDimentions3 = _interopRequireDefault(_getProjectDimentions2);

var _getNodesRects = require('components/Projects/utils/getNodesRects');

var _getNodesRects2 = _interopRequireDefault(_getNodesRects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectRenderer = (_temp = _class = function (_Component) {
  _inherits(ProjectRenderer, _Component);

  function ProjectRenderer() {
    _classCallCheck(this, ProjectRenderer);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectRenderer).apply(this, arguments));
  }

  _createClass(ProjectRenderer, [{
    key: 'render',
    value: function render() {
      var project = this.props.project;
      var graph = project.graph;
      var nodesData = project.nodesData;

      // get the svg width & height

      var _getProjectDimentions = (0, _getProjectDimentions3.default)(project);

      var width = _getProjectDimentions.width;
      var height = _getProjectDimentions.height;
      var minByX = _getProjectDimentions.minByX;
      var minByY = _getProjectDimentions.minByY;

      var nodesRects = (0, _getNodesRects2.default)(project);

      var translateX = -minByX.x + minByX.width / 2;
      var translateY = -minByY.y + minByY.height / 2;

      return _react2.default.createElement(_StaticProjectView2.default, {
        graph: graph, nodesData: nodesData, nodesRects: nodesRects,

        viewX: translateX, viewY: translateY,
        viewWidth: width, viewHeight: height
      });
    }
  }]);

  return ProjectRenderer;
}(_react.Component), _class.propTypes = {
  project: _react.PropTypes.object.isRequired
}, _temp);
exports.default = ProjectRenderer;


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectRenderer/ProjectRenderer.js
// module id = 588
// module chunks = 1